// extracted by mini-css-extract-plugin
export default {"customAccordion":"CustomAccordion_customAccordion__t-4i+","closeBtnWrapper":"CustomAccordion_closeBtnWrapper__z8B8x","closeBtn":"CustomAccordion_closeBtn__z78MJ"};